/**
 * 앱 버전 (semver). 빌드 전에 `.cursor/rules/build-version.mdc` 기준으로 올린다.
 * 로그인 화면 우측 하단 · 사이드바 푸터에 표시.
 */
export const FRONTEND_VERSION = "1.2.2";
